import {useMutation} from "@apollo/client";
import {toast} from "react-hot-toast";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_STATUS_PAGE_QUERY, GQL_UPDATE_METRIC, UpdateMetricResult} from "@/lib/queries/statuspages.ts";
import {Metric} from "@/lib/types/statuspages.ts";
import StatusPageSystemMetricForm, {
  StatusPageSystemMetricFormValues,
} from "@/pages/statuspages/tabs/systemMetrics/systemMetricModal/StatusPageSystemMetricForm.tsx";

interface StatusPageSystemMetricUpdateModalProps {
  className?: string;
  title: string;
  submitBtnText?: string;
  metric?: Metric;
  statusPageID: number;
  setShow: (show: boolean) => void;
  show: boolean;
}

export const StatusPageSystemMetricUpdateModal = ({
  metric,
  title,
  show,
  setShow,
  statusPageID,
  submitBtnText,
}: StatusPageSystemMetricUpdateModalProps) => {
  const [updateMetric, {data, loading, reset, client}] = useMutation<UpdateMetricResult>(GQL_UPDATE_METRIC, {});

  const formId = "systemMetricForm";

  const handleSubmit = async (formData: StatusPageSystemMetricFormValues) => {
    const response = await updateMetric({
      variables: {
        statusPageID: statusPageID,
        data: {
          id: formData.id,
          name: formData.name,
          service: formData.service,
          is_visible: formData.is_visible,
        },
      },
    });
    if (response?.data?.updateMetric?.success) {
      await client.refetchQueries({include: [GQL_STATUS_PAGE_QUERY]});
      const toastMessage = metric ? "System Metric updated." : "System Metric created.";
      toast.success(toastMessage);
      setShow(false);
    }
  };

  return (
    <FormModal
      className="px-2"
      placement="end"
      size="lg"
      disabled={loading}
      formId={formId}
      hasRequiredFields
      submitBtnText={submitBtnText}
      onCancel={() => {
        setShow(false);
        reset();
      }}
      show={show}
      title={title}
    >
      <StatusPageSystemMetricForm
        id={formId}
        metric={metric}
        serverErrors={data?.updateMetric?.errors}
        onSubmit={handleSubmit}
      />
    </FormModal>
  );
};
